"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_2 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_3 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_4 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_5 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_6 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_7 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_8 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_9 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_10 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_11 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_12 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_13 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_14 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_15 = require("@biomemakers/bmk_ui_framework");
const TrialsPanel_vue_1 = __importDefault(require("../TrialsPanel.vue"));
const floating_vue_1 = require("floating-vue");
const lucide_vue_next_1 = require("lucide-vue-next");
const MixpanelHandler_1 = __importDefault(require("@becrop/components/Modules/Common/Models/MixpanelHandler"));
const axios_1 = __importDefault(require("axios"));
const ModalsSelectsModuleResults_vue_1 = __importDefault(require("../AreaProjectMap/ModalsSelectsModuleResults.vue"));
let TableProjects = class TableProjects extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        // MixPanel init
        this.mixpanelHandler = new MixpanelHandler_1.default();
        this.selectedAreaId = 0;
        this.areaName = '';
        this.activeQRModal = false;
        this.activeTrialsPanel = false;
        this.newVisibility = false;
        this.reportVisibility = 'private';
        this.arrayReportVisibility = [];
        this.oldToken = '';
        this.currentTrial = null;
        this.trialsDeliverables = this.trials;
        this.prodID = null;
        this.trial = null;
        this.criteriaArr = [];
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    f() {
        console.log(this.activeQr === this.oldToken);
        this.oldToken = this.activeQr;
    }
    seeQrCode(trial) {
        this.currentTrial = trial;
        this.deployQRModal();
        this.$emit('reloadTrial', trial.id);
    }
    isPublic(id) {
        for (const trial of this.trialsDeliverables) {
            if (trial.id === id) {
                if (trial.is_published) {
                    return true;
                }
                else {
                    return false;
                }
            }
        }
    }
    async changeVisibility(trial) {
        if (trial.is_published) {
            this.$emit('isFeedbackToastActive', 'private');
        }
        else {
            this.$emit('isFeedbackToastActive', 'public');
        }
        await axios_1.default.get('/trials/' + trial.id + '/setIsPublished');
        this.trialsDeliverables = this.trialsDeliverables.map((p) => {
            const newP = p;
            if (newP.id === trial.id) {
                newP.is_published = !newP.is_published;
            }
            return newP;
        });
    }
    downloadSummary(trial) {
        window.open(`/trials/summary/report/${trial.id}`);
    }
    getAllTimesForTrial(trial) {
        const STAGES = trial.stages;
        const set = new Set(STAGES);
        const stagesUnicos = [...set];
        const stagesUnicosFilterTime0 = stagesUnicos.filter((item) => {
            return item.time !== 0;
        });
        const times = [];
        for (const time of stagesUnicosFilterTime0) {
            times.push(time.time);
        }
        const setTimes = new Set(times);
        const timesUnicos = [...setTimes];
        return timesUnicos.length;
    }
    getAllLocationsForTrial(trial) {
        const STAGES = trial.stages;
        const times = [];
        for (const time of STAGES) {
            times.push(time.location_id);
        }
        const setTimes = new Set(times);
        const timesUnicos = [...setTimes];
        return timesUnicos.length;
    }
    getVersion(trial) {
        var _a;
        return ((_a = trial.reports2[0]) === null || _a === void 0 ? void 0 : _a.version) || null;
    }
    deployQRModal() {
        this.activeQRModal = true;
    }
    dismissQRModal() {
        this.activeQRModal = false;
    }
    showTrialsSummaryTable(trial) {
        this.trial = trial;
        const originModule = localStorage.getItem('currentModule');
        this.mixpanelHandler.trackEvent('showTrialsSummaryTable', {
            origin: originModule,
        });
        window.location.href = `/results/project/${this.projectBagId}/summary/trials/${this.trial.id}`;
    }
    deployTrialsPanel(trial) {
        this.activeTrialsPanel = true;
        this.trial = trial;
        this.deployTrialsPanelMixpanel();
    }
    deployTrialsPanelMixpanel() {
        const originModule = localStorage.getItem('currentModule');
        this.mixpanelHandler.trackEvent('deployTrialsPanel', {
            origin: originModule,
        });
    }
    dismissTrialsPanel() {
        this.activeTrialsPanel = false;
        this.dismissTrialsPanelMixpanel();
    }
    dismissTrialsPanelMixpanel() {
        const originModule = localStorage.getItem('currentModule');
        this.mixpanelHandler.trackEvent('dismissTrialsPanel', {
            origin: originModule,
        });
    }
    downloadReport(id) {
        window.open('/data/results/certificate/' + id, '_blank');
        this.downloadReportMixpanel(id);
    }
    downloadReportMixpanel(value) {
        const originModule = localStorage.getItem('currentModule');
        const certificateId = value;
        this.mixpanelHandler.trackEvent('downloadReportRate', {
            origin: originModule,
            certificateId: certificateId,
        });
    }
    seeQR(id, name) {
        this.deployQRModal();
    }
    seeQRMixpanel(id, areaName) {
        const originModule = localStorage.getItem('currentModule');
        this.mixpanelHandler.trackEvent('seeQR', {
            origin: originModule,
            certificateId: id,
            areaName: areaName,
        });
    }
    toggleVisibility(id, currentVisibility) {
        this.newVisibility = !currentVisibility;
        this.$emit('toggleVisibility', id, this.newVisibility);
        this.toggleVisibilityMixpanel(id, currentVisibility);
    }
    toggleVisibilityMixpanel(reportId, currentVisibility) {
        const originModule = localStorage.getItem('currentModule');
        let visibility = 'Public';
        if (currentVisibility) {
            visibility = 'Private';
        }
        this.mixpanelHandler.trackEvent('toggleVisibilityRate', {
            origin: originModule,
            reportId: reportId,
            currentVisibility: visibility,
        });
    }
    beautifyExtension(s) {
        if (s) {
            const stringedExt = s.toString();
            let beautyExt = stringedExt.substring(0, stringedExt.indexOf('.'));
            let midString, endString = '';
            if (stringedExt.lastIndexOf('e') !== -1) {
                midString = stringedExt.substring(stringedExt.indexOf('.'), stringedExt.lastIndexOf('e'));
                midString = midString.substr(0, 3);
                endString = stringedExt.substring(stringedExt.indexOf('e'), stringedExt.length);
            }
            else {
                midString = stringedExt.substr(stringedExt.indexOf('.'), stringedExt.length);
                midString = midString.substr(0, 3);
            }
            return beautyExt + midString + endString;
        }
        return '-';
    }
    shortMixpanel(value) {
        const originModule = localStorage.getItem('currentModule');
        const criteria = value;
        let direction = this.direction;
        this.criteriaArr.push(criteria);
        if (this.criteriaArr.length >= 2) {
            if (this.criteriaArr[0] !== this.criteriaArr[1]) {
                direction = 0;
            }
            this.criteriaArr.shift();
        }
        if (direction === 0) {
            direction = 1;
        }
        else if (direction === 1) {
            direction = -1;
        }
        else if (direction === -1) {
            direction = 0;
        }
        this.mixpanelHandler.trackEvent('proposalsDetailListSorting', {
            direction: direction,
            criteria: criteria,
            origin: originModule,
        });
    }
    chooseSortable(c) {
        this.$emit('updateSortable', c);
        this.shortMixpanel(c);
    }
    launchResult(pId, aId) {
        window.location.href = '/results/map?projectId=' + pId + '&areaId=' + aId;
        this.launchResultMixpanel(pId, aId);
    }
    launchResultMixpanel(projectId, areaId) {
        const originModule = localStorage.getItem('currentModule');
        this.mixpanelHandler.trackEvent('launchResult', {
            origin: originModule,
            projectId: projectId,
            areaId: areaId,
        });
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], TableProjects.prototype, "trials", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], TableProjects.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], TableProjects.prototype, "theadElements", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], TableProjects.prototype, "textSearch", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], TableProjects.prototype, "activeQr", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], TableProjects.prototype, "criteria", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 0 })
], TableProjects.prototype, "direction", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: null })
], TableProjects.prototype, "projectBagId", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: '' })
], TableProjects.prototype, "proposalCode", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('activeQr')
], TableProjects.prototype, "f", null);
TableProjects = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            DateStylized: bmk_ui_framework_1.DateStylized,
            TrialsLogo: bmk_ui_framework_1.TrialsLogo,
            RateLogo: bmk_ui_framework_1.RateLogo,
            YieldLogo: bmk_ui_framework_1.YieldLogo,
            FarmLogo: bmk_ui_framework_1.FarmLogo,
            DiseasesLogo: bmk_ui_framework_1.DiseasesLogo,
            ManagementLogo: bmk_ui_framework_1.ManagementLogo,
            TableHeader: bmk_ui_framework_2.TableHeader,
            TableHeaderCell: bmk_ui_framework_3.TableHeaderCell,
            TableBmk: bmk_ui_framework_4.TableBmk,
            TableBody: bmk_ui_framework_5.TableBody,
            TableBodyRow: bmk_ui_framework_6.TableBodyRow,
            TableBodyCell: bmk_ui_framework_7.TableBodyCell,
            Modal: bmk_ui_framework_8.Modal,
            ViewZero: bmk_ui_framework_11.ViewZero,
            MagnifyingGlassIcon: bmk_ui_framework_9.MagnifyingGlassIcon,
            CrossIcon: bmk_ui_framework_10.CrossIcon,
            Button: bmk_ui_framework_14.Button,
            InputField: bmk_ui_framework_15.InputField,
            Toasts: bmk_ui_framework_12.Toasts,
            Tag: bmk_ui_framework_13.Tag,
            TrialsPanel: TrialsPanel_vue_1.default,
            Dropdown: floating_vue_1.Dropdown,
            Mail: lucide_vue_next_1.Mail,
            Lock: lucide_vue_next_1.Lock,
            Eye: lucide_vue_next_1.Eye,
            ArrowUpRight: lucide_vue_next_1.ArrowUpRight,
            ArrowRight: lucide_vue_next_1.ArrowRight,
            ArrowDown: lucide_vue_next_1.ArrowDown,
            QrCode: lucide_vue_next_1.QrCode,
            Key: lucide_vue_next_1.Key,
            LoaderBuild: bmk_ui_framework_1.LoaderBuild,
            LayoutGrid: lucide_vue_next_1.LayoutGrid,
            FileText: lucide_vue_next_1.FileText,
            ModalsSelectsModuleResults: ModalsSelectsModuleResults_vue_1.default,
        },
    })
], TableProjects);
exports.default = TableProjects;
